import { useState, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import WalkinIcon from '@mui/icons-material/Snowshoeing';

import {selectPendingRequestCount, fetchRequests} from "../store/requestSlice";

const PendingRequestBadge = ()=>{

    const [tmCounter, setTmCounter] = useState(0)
    //const count = useSelector(selectUnreadNotificationCount);
    const count = useSelector(selectPendingRequestCount);
    //const timestamp = useSelector(selectNotificationTimestame);
    const dispatch = useDispatch()


    useEffect(() => {
        const interval = setInterval(() => {
          console.log('This will =='+Date.now()+"-------------"+count);
           setTmCounter(x=>x+1)
        }, 90*1000);
        return () => clearInterval(interval);
      }, []);

      useEffect(() => {
        
          console.log('OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOwill =='+tmCounter);
          dispatch(fetchRequests())
        
      }, [dispatch, tmCounter]);


      return (

        <Badge badgeContent={count} color="error">
            <WalkinIcon sx={{fontSize:32}} />
        </Badge>



      )
}


export default PendingRequestBadge;